import { render, staticRenderFns } from "./editUserSubscriptions.vue?vue&type=template&id=162d2808&"
import script from "./editUserSubscriptions.vue?vue&type=script&lang=js&"
export * from "./editUserSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports